import {BrandID} from "../enums/brand-id";

export class Role {

  id: number = 0;
  name!: string;
  description!: string;
  brandID!: BrandID;
}
